// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core from "@material-ui/core";
import * as App_Icon$DvmAdminFrontendFr from "../../common/components/icons/App_Icon.bs.js";
import * as App_Table$DvmAdminFrontendFr from "../../common/components/table/App_Table.bs.js";
import * as Intl_Utils$DvmAdminFrontendFr from "../../intl/Intl_Utils.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../context/user/User_Context.bs.js";
import * as App_Table_Head$DvmAdminFrontendFr from "../../common/components/table/App_Table_Head.bs.js";
import * as App_Table_Types$DvmAdminFrontendFr from "../../common/components/table/App_Table_Types.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../intl/messages/Messages_Common.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../common/types/App_Types_Result.bs.js";
import * as User_Types_Utils$DvmAdminFrontendFr from "../../context/user/User_Types_Utils.bs.js";
import * as Messages_Statuses$DvmAdminFrontendFr from "../../intl/messages/Messages_Statuses.bs.js";
import * as Pool_Expenses_Types$DvmAdminFrontendFr from "./Pool_Expenses_Types.bs.js";
import * as App_Table_Pagination$DvmAdminFrontendFr from "../../common/components/table/App_Table_Pagination.bs.js";
import * as Messages_Pool_Expenses$DvmAdminFrontendFr from "../../intl/messages/poolExpenses/Messages_Pool_Expenses.bs.js";
import * as Pool_Expenses_Update_Modal$DvmAdminFrontendFr from "./modal/Pool_Expenses_Update_Modal.bs.js";
import * as Pool_Expenses_Available_Expenses_Button$DvmAdminFrontendFr from "./Pool_Expenses_Available_Expenses_Button.bs.js";

function headersConfiguration(tableType, selectedRole) {
  return Belt_List.keepMap({
              hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Pool_Expenses_Types$DvmAdminFrontendFr.Fields.year, /* Desc */1, undefined, undefined, undefined, undefined, Messages_Common$DvmAdminFrontendFr.year),
              tl: {
                hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Pool_Expenses_Types$DvmAdminFrontendFr.Fields.periodID, undefined, undefined, undefined, undefined, undefined, Messages_Common$DvmAdminFrontendFr.period),
                tl: {
                  hd: (User_Types_Utils$DvmAdminFrontendFr.isAdmin(selectedRole) || selectedRole === /* DPR */10 || selectedRole === /* RMPC */9) && tableType === /* MR */1 ? App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Pool_Expenses_Types$DvmAdminFrontendFr.Fields.nameRmpc, undefined, undefined, undefined, undefined, undefined, Messages_Pool_Expenses$DvmAdminFrontendFr.rmpcNameLabel) : undefined,
                  tl: {
                    hd: tableType ? App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Pool_Expenses_Types$DvmAdminFrontendFr.Fields.nameMr, undefined, undefined, undefined, undefined, undefined, Messages_Pool_Expenses$DvmAdminFrontendFr.mrNameLabel) : App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Pool_Expenses_Types$DvmAdminFrontendFr.Fields.nameRmpc, undefined, undefined, undefined, undefined, undefined, Messages_Pool_Expenses$DvmAdminFrontendFr.rmpcNameLabel),
                    tl: {
                      hd: tableType ? App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Pool_Expenses_Types$DvmAdminFrontendFr.Fields.mr, undefined, undefined, undefined, undefined, undefined, Messages_Pool_Expenses$DvmAdminFrontendFr.mrIpnLabel) : App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Pool_Expenses_Types$DvmAdminFrontendFr.Fields.rmpc, undefined, undefined, undefined, undefined, undefined, Messages_Pool_Expenses$DvmAdminFrontendFr.rmpcIpnLabel),
                      tl: {
                        hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Pool_Expenses_Types$DvmAdminFrontendFr.Fields.allocatedResources, undefined, undefined, "right", undefined, undefined, Messages_Pool_Expenses$DvmAdminFrontendFr.allocatedResources),
                        tl: {
                          hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Pool_Expenses_Types$DvmAdminFrontendFr.Fields.unvalidatableRequestsAmount, undefined, undefined, "right", undefined, undefined, Messages_Statuses$DvmAdminFrontendFr.blocked),
                          tl: {
                            hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Pool_Expenses_Types$DvmAdminFrontendFr.Fields.validatableRequestsAmount, undefined, undefined, "right", undefined, undefined, Messages_Statuses$DvmAdminFrontendFr.toValidate),
                            tl: {
                              hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Pool_Expenses_Types$DvmAdminFrontendFr.Fields.validatedRequestsAmount, undefined, undefined, "right", undefined, undefined, Messages_Statuses$DvmAdminFrontendFr.validated),
                              tl: {
                                hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Pool_Expenses_Types$DvmAdminFrontendFr.Fields.finishedRequestsAmount, undefined, undefined, "right", undefined, undefined, Messages_Pool_Expenses$DvmAdminFrontendFr.finishedRequestsAmount),
                                tl: {
                                  hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Pool_Expenses_Types$DvmAdminFrontendFr.Fields.remainingResources, undefined, undefined, "right", undefined, undefined, Messages_Pool_Expenses$DvmAdminFrontendFr.remainingResources),
                                  tl: {
                                    hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Pool_Expenses_Types$DvmAdminFrontendFr.Fields.startDate, undefined, undefined, "right", undefined, undefined, Messages_Common$DvmAdminFrontendFr.startDate),
                                    tl: {
                                      hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Pool_Expenses_Types$DvmAdminFrontendFr.Fields.endDate, undefined, undefined, "right", undefined, undefined, Messages_Common$DvmAdminFrontendFr.endDate),
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }, (function (x) {
                return x;
              }));
}

function Pool_Expenses_Table(Props) {
  var tablePage = Props.tablePage;
  var fetchRequest = Props.fetchRequest;
  var fetchData = Props.fetchData;
  var operation = Props.operation;
  var tableType = Props.tableType;
  var intl = ReactIntl.useIntl();
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var selectedRole = match[0].selectedRole;
  var match$1 = React.useState(function () {
        return null;
      });
  var setModal = match$1[1];
  var onCloseModal = function (param) {
    Curry._1(setModal, (function (param) {
            return null;
          }));
    Curry._2(fetchData, undefined, fetchRequest);
  };
  var convertTable = function (table) {
    return App_Types_Result$DvmAdminFrontendFr.map(table, (function (param) {
                  return {
                          content: Belt_List.map(param.content, (function (row) {
                                  return App_Table_Types$DvmAdminFrontendFr.makeRow(undefined, operation === /* Manage */1 ? Caml_option.some(React.createElement(Core.Grid, {
                                                        children: React.createElement(Core.Button, {
                                                              onClick: (function (param) {
                                                                  Curry._1(setModal, (function (param) {
                                                                          return React.createElement(Pool_Expenses_Update_Modal$DvmAdminFrontendFr.make, {
                                                                                      onClose: (function (param) {
                                                                                          onCloseModal(undefined);
                                                                                        }),
                                                                                      row: row,
                                                                                      onOk: (function (param) {
                                                                                          onCloseModal(undefined);
                                                                                        }),
                                                                                      tableType: tableType
                                                                                    });
                                                                        }));
                                                                }),
                                                              children: React.createElement(App_Icon$DvmAdminFrontendFr.make, {
                                                                    size: /* Large */3,
                                                                    type_: /* Edit */60
                                                                  }),
                                                              key: "edit"
                                                            }),
                                                        item: true
                                                      })) : undefined, undefined, Belt_List.mapWithIndex(Belt_List.keepMap({
                                                      hd: row.year,
                                                      tl: {
                                                        hd: row.periodID,
                                                        tl: {
                                                          hd: (User_Types_Utils$DvmAdminFrontendFr.isAdmin(selectedRole) || selectedRole === /* DPR */10 || selectedRole === /* RMPC */9) && tableType === /* MR */1 ? Belt_Option.getWithDefault(row.nameRmpc, "") : undefined,
                                                          tl: {
                                                            hd: tableType ? Belt_Option.getWithDefault(row.nameMr, "") : Belt_Option.getWithDefault(row.nameRmpc, ""),
                                                            tl: {
                                                              hd: tableType ? Belt_Option.getWithDefault(row.mr, "") : Belt_Option.getWithDefault(row.rmpc, ""),
                                                              tl: {
                                                                hd: Belt_Option.mapWithDefault(row.allocatedResources, "", (function (prim) {
                                                                        return String(prim);
                                                                      })),
                                                                tl: {
                                                                  hd: Belt_Option.mapWithDefault(row.unvalidatableRequestsAmount, "", (function (prim) {
                                                                          return String(prim);
                                                                        })),
                                                                  tl: {
                                                                    hd: Belt_Option.mapWithDefault(row.validatableRequestsAmount, "", (function (prim) {
                                                                            return String(prim);
                                                                          })),
                                                                    tl: {
                                                                      hd: Belt_Option.mapWithDefault(row.validatedRequestsAmount, "", (function (prim) {
                                                                              return String(prim);
                                                                            })),
                                                                      tl: {
                                                                        hd: Belt_Option.mapWithDefault(row.finishedRequestsAmount, "", (function (prim) {
                                                                                return String(prim);
                                                                              })),
                                                                        tl: {
                                                                          hd: Belt_Option.mapWithDefault(row.remainingResources, "", (function (prim) {
                                                                                  return String(prim);
                                                                                })),
                                                                          tl: {
                                                                            hd: Belt_Option.mapWithDefault(row.startDate, "", (function (param) {
                                                                                    return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                                                                  })),
                                                                            tl: {
                                                                              hd: Belt_Option.mapWithDefault(row.endDate, "", (function (param) {
                                                                                      return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                                                                    })),
                                                                              tl: /* [] */0
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }, (function (x) {
                                                        return x;
                                                      })), (function (index, content) {
                                                    return App_Table$DvmAdminFrontendFr.makeCell(Belt_Option.map(Belt_List.get(headersConfiguration(tableType, selectedRole), index), (function (param) {
                                                                      return param.align;
                                                                    })), undefined, undefined, content);
                                                  })));
                                })),
                          currentPage: fetchRequest.page,
                          totalElements: param.total
                        };
                }));
  };
  var handleSorting = function (headers) {
    Curry._2(fetchData, undefined, {
          page: fetchRequest.page,
          rowsPerPage: fetchRequest.rowsPerPage,
          headers: headers,
          filterQueryParams: fetchRequest.filterQueryParams,
          additionalQueryParams: fetchRequest.additionalQueryParams
        });
  };
  var handleChangePage = function (page) {
    Curry._2(fetchData, undefined, {
          page: page,
          rowsPerPage: fetchRequest.rowsPerPage,
          headers: fetchRequest.headers,
          filterQueryParams: fetchRequest.filterQueryParams,
          additionalQueryParams: fetchRequest.additionalQueryParams
        });
  };
  var handleRowsPerPageChange = function (rowsPerPage) {
    Curry._2(fetchData, undefined, {
          page: 0,
          rowsPerPage: rowsPerPage,
          headers: fetchRequest.headers,
          filterQueryParams: fetchRequest.filterQueryParams,
          additionalQueryParams: fetchRequest.additionalQueryParams
        });
  };
  var tmp = {
    headers: fetchRequest.headers,
    handleSorting: handleSorting,
    tablePage: convertTable(tablePage),
    paginator: App_Table_Pagination$DvmAdminFrontendFr.makePaginator(undefined, undefined, handleChangePage, handleRowsPerPageChange, undefined)
  };
  var tmp$1 = (User_Types_Utils$DvmAdminFrontendFr.isAdmin(selectedRole) || selectedRole === /* DPR */10 || selectedRole === /* RMPC */9) && operation === /* Manage */1 ? ({
        TAG: /* Left */0,
        _0: /* EmptyCell */0
      }) : undefined;
  if (tmp$1 !== undefined) {
    tmp.rowButton = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = selectedRole === /* RMPC */9 ? Caml_option.some(React.createElement(Pool_Expenses_Available_Expenses_Button$DvmAdminFrontendFr.make, {
              level: /* RMPC */0
            })) : undefined;
  if (tmp$2 !== undefined) {
    tmp.exportMenu = Caml_option.valFromOption(tmp$2);
  }
  return React.createElement(React.Fragment, undefined, React.createElement(App_Table$DvmAdminFrontendFr.make, tmp), match$1[0]);
}

var make = Pool_Expenses_Table;

export {
  headersConfiguration ,
  make ,
}
/* react Not a pure module */
